module.exports = __webpack_public_path__ + "028bbf8b0b4885dcd89a9319b1bc3804.png";